__turbopack_context__.v({
  "actionBtn": "SidebarPlan-module__dykIeq__actionBtn",
  "amount": "SidebarPlan-module__dykIeq__amount",
  "amountRow": "SidebarPlan-module__dykIeq__amountRow",
  "card": "SidebarPlan-module__dykIeq__card",
  "collapsed": "SidebarPlan-module__dykIeq__collapsed",
  "icon": "SidebarPlan-module__dykIeq__icon",
  "left": "SidebarPlan-module__dykIeq__left",
  "title": "SidebarPlan-module__dykIeq__title",
});
